import { getLocationIds } from './get_geo_ids';
import { getVillageBuildingTypes } from './get_village_building_types';
import { IVillageSchema } from '../types';

export const getCustomUrl = (village: IVillageSchema, id = village.id): string => {
  const villageBuildingTypes = getVillageBuildingTypes(village);

  const params: Array<string | undefined | boolean | number> = [];
  const [moId, oblId, cityId] = getLocationIds(village.geo);

  params.push('sale');
  params.push('KP');

  params.push(`mo_id=${moId}`);
  params.push(`obl_id=${oblId}`);
  params.push(`city_id=${cityId}`);

  params.push('object_type=2');
  params.push(`ga_obj_type=${villageBuildingTypes}`);

  params.push('spec=company');
  params.push(id);

  params.push('from_developer=1');
  params.push('repres=0');
  params.push('owner=1');
  params.push('pod_snos=1');
  params.push('nv=0');

  return `/${params.filter(Boolean).join('/')}/`;
};
